import React from 'react';

import History from '../../containers/history';
import PrivateRoute from '../../hocs/private-route';

const HistoryPage = props => {
  return <PrivateRoute as={History} {...props}></PrivateRoute>;
};

export default HistoryPage;
